import { createContext } from "react";
interface UserInformation {
  id: any;
  token: string;
  fullName: string;
  mobile: string;
  shopIds: number[];
  ccShopIds: number[];
}
interface AuthenticationInterface {
  userInfo: UserInformation;
  isLogged: boolean;
  setUserInfo: (shopInfo: any) => void;
  login: (info: any) => void;
  logout: () => void;
}

const AuthenticationContext = createContext<AuthenticationInterface>({
  userInfo: {
    token: "",
    fullName: "",
    ccShopIds: [],
    shopIds: [],
    mobile: "",
    id: null,
  },
  isLogged: false,
  setUserInfo: () =>{},
  login: (info) => {},
  logout: () => {},
});
export default AuthenticationContext;
// account types:
